module.exports = __webpack_public_path__ + "img/DCS_0472.f23baf7c.jpg";